// blakfy-cookie/src/i18n/translations/uk.js — Ukrainian translations

export default {
  title: "Налаштування файлів cookie",
  intro:
    "Цей сайт використовує файли cookie для покращення вашого досвіду. Дивіться нашу Політику cookie.",
  policyLink: "Політика cookie",
  acceptAll: "Прийняти всі",
  rejectAll: "Відхилити всі",
  preferences: "Налаштування",
  save: "Зберегти вибір",
  close: "Закрити",
  cat: {
    essential: {
      title: "Обов'язкові cookie",
      desc: "Необхідні для роботи сайту. Не можуть бути вимкнені.",
      always: "Завжди активні",
    },
    analytics: {
      title: "Аналітичні cookie",
      desc: "Використовуються для збору анонімної статистики відвідувань.",
    },
    marketing: {
      title: "Маркетингові cookie",
      desc: "Використовуються для персоналізованої реклами та ретаргетингу.",
    },
    functional: {
      title: "Функціональні cookie",
      desc: "Використовуються для запам'ятовування налаштувань мови, теми тощо.",
    },
  },
  placeholder: {
    title: "Вміст заблоковано",
    desc: "Щоб переглянути цей вміст, дозвольте файли cookie категорії {category}.",
    cta: "Дозволити",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
